import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const CLINIC = {
  name: "Shah Eye Care Centre",
  tagline: "Where Trust meets Vision",
  address: "H No 217, Sector 7, Channi Himmat, Jammu",
  phone: "9906168179",
  fee: 300,
  upiId: "shaheyecarecentre@okhdfcbank",
};

export const upiString = () =>
  `upi://pay?pa=${CLINIC.upiId}&pn=${encodeURIComponent(CLINIC.name)}&am=${CLINIC.fee}&cu=INR&tn=${encodeURIComponent("Consultation Fee")}`;
